import React from "react";
import { useField } from "formik";
import InputMask from "react-input-mask";
import styles from "./TextFieldV3.module.scss";

export default ({
  label,
  variant,
  placeholder,
  area,
  cityAutocomplete,
  noLabel,
  validateSymbols,
  bare,
  ...props
}) => {
  const [field, meta, helpers] = useField(props.name);
  const invalidAttr = meta.touched ? !props.noValidate && meta.error : undefined;
  const onChangeHandler = (event) => {
    if (validateSymbols) {
      const data = validateSymbols(event.target.value);
      helpers.setValue(data);
    } else if (field.name === "iban" || field.name === "bic_swift") {
      helpers.setValue(event.target.value.trim());
    } else helpers.setValue(event.target.value);
  };
  if (bare) {
    return (
      <>
        {label && !noLabel && <span className={styles.label}>{label}</span>}
        {area ? (
          <textarea
            placeholder={placeholder}
            rows={3}
            {...props}
            {...field}
            onChange={onChangeHandler}
            invalid={invalidAttr}
          />
        ) : props.type === "date" ? (
          <InputMask
            mask="99.99.9999"
            maskPlaceholder={props.maskPlaceholder}
            {...field}
            type="text"
            onChange={onChangeHandler}
            onBlur={field.onBlur}
          >
            <input placeholder={placeholder || " "} invalid={invalidAttr} />
          </InputMask>
        ) : (
          <>
            {props.hasOwnProperty("huge") ? (
              <textarea
                placeholder={placeholder || " "}
                {...props}
                {...field}
                onChange={onChangeHandler}
                className={styles.huge}
                invalid={invalidAttr}
              />
            ) : (
              <input
                placeholder={placeholder || " "}
                {...props}
                {...field}
                onChange={onChangeHandler}
                className={styles.normal}
                invalid={invalidAttr}
              />
            )}
          </>
        )}
      </>
    );
  }

  return (
    <div
      className={`${styles.TextField} ${styles[variant]}`}
      invalid={invalidAttr}
    >
      {label && !noLabel && <span className={styles.label}>{label}</span>}
      {area ? (
        <textarea
          placeholder={placeholder}
          rows={3}
          {...props}
          {...field}
          onChange={onChangeHandler}
        />
      ) : props.type === "date" ? (
        <InputMask
          mask="99.99.9999"
          maskPlaceholder={props.maskPlaceholder}
          {...field}
          type="text"
          onChange={onChangeHandler}
          onBlur={field.onBlur}
        >
          <input placeholder={placeholder || " "} />
        </InputMask>
      ) : (
        <>
          {props.hasOwnProperty("huge") ? (
            <textarea
              placeholder={placeholder || " "}
              {...props}
              {...field}
              onChange={onChangeHandler}
              className={styles.huge}
            />
          ) : (
            <input
              placeholder={placeholder || " "}
              {...props}
              {...field}
              onChange={onChangeHandler}
              className={styles.normal}
            />
          )}
        </>
      )} {" "}
    </div>
  );
};
